import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { env } from "@/env";

export const appInsightReactPlugin = new ReactPlugin();

const connectionString = env.appInsightsConnectionString;

export const appInsights = new ApplicationInsights({
  config: {
    connectionString,
    // don't rely on history here; we'll call trackPageView from router events
    enableAutoRouteTracking: false,
    extensions: [appInsightReactPlugin],
    extensionConfig: {},
  },
});

export const initAppInsights = () => {
  if (!connectionString) return;
  appInsights.loadAppInsights();
  appInsights.trackPageView();
};
